import { render, staticRenderFns } from "./FlightReservation.vue?vue&type=template&id=2a317718&scoped=true&"
import script from "./FlightReservation.vue?vue&type=script&lang=js&"
export * from "./FlightReservation.vue?vue&type=script&lang=js&"
import style0 from "./FlightReservation.vue?vue&type=style&index=0&id=2a317718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a317718",
  null
  
)

export default component.exports